/* tslint:disable */
/* eslint-disable */
/**
 * Content-A service
 * Content Service API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-Content_Team@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiAnalytics,
  ApiAnalyticsFromJSON,
  ApiAnalyticsFromJSONTyped,
  ApiAnalyticsToJSON,
} from './ApiAnalytics';
import {
  ApiComponent,
  ApiComponentFromJSON,
  ApiComponentFromJSONTyped,
  ApiComponentToJSON,
} from './ApiComponent';
import { ApiHeader, ApiHeaderFromJSON, ApiHeaderFromJSONTyped, ApiHeaderToJSON } from './ApiHeader';
import {
  ApiInstrumentation,
  ApiInstrumentationFromJSON,
  ApiInstrumentationFromJSONTyped,
  ApiInstrumentationToJSON,
} from './ApiInstrumentation';
import {
  ApiShopNavAllOf,
  ApiShopNavAllOfFromJSON,
  ApiShopNavAllOfFromJSONTyped,
  ApiShopNavAllOfToJSON,
} from './ApiShopNavAllOf';
import {
  ApiShopNavItem,
  ApiShopNavItemFromJSON,
  ApiShopNavItemFromJSONTyped,
  ApiShopNavItemToJSON,
} from './ApiShopNavItem';

/**
 *
 * @export
 * @interface ApiShopNav
 */
export interface ApiShopNav extends ApiComponent {
  /**
   *
   * @type {Array<ApiShopNavItem>}
   * @memberof ApiShopNav
   */
  items?: Array<ApiShopNavItem>;
  /**
   *
   * @type {ApiHeader}
   * @memberof ApiShopNav
   */
  header?: ApiHeader;
}

export function ApiShopNavFromJSON(json: any): ApiShopNav {
  return ApiShopNavFromJSONTyped(json, false);
}

export function ApiShopNavFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiShopNav {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    ...ApiComponentFromJSONTyped(json, ignoreDiscriminator),
    items: !exists(json, 'items')
      ? undefined
      : (json['items'] as Array<any>).map(ApiShopNavItemFromJSON),
    header: !exists(json, 'header') ? undefined : ApiHeaderFromJSON(json['header']),
  };
}

export function ApiShopNavToJSON(value?: ApiShopNav | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    ...ApiComponentToJSON(value),
    items:
      value.items === undefined ? undefined : (value.items as Array<any>).map(ApiShopNavItemToJSON),
    header: ApiHeaderToJSON(value.header),
  };
}
